import AddLocalAdmin from './AddLocalAdmin';

export default AddLocalAdmin;
